import { useEffect, useState } from "react";
import ReassignResultComponent from "./reassign-result.component";

export default function ReassignResultContainer({ result, onClose }) {
  return <ReassignResultComponent result={result} onClose={onClose} />;
}
